import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Select, Space, Typography, message } from 'antd';
import SeoFieldsPanel from '../../components/Seo/SeoFieldsPanel';
import { EMPTY_SEO } from '../../components/Seo/seoConstants';
import seoAdminService from '../../services/seoAdminService';

const { Text } = Typography;
const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3003';

const FEATURE_PAGES = [
  {
    pageKey: 'features',
    label: 'Liste des fonctionnalités',
    path: '/fonctionnalites',
    defaults: {
      metaTitle: 'Fonctionnalités | Earth Forum',
      metaDescription: 'Découvrez les fonctionnalités d\'Earth Forum et comment en profiter.',
    },
  },
  {
    pageKey: 'features_themes',
    label: 'Thèmes personnage & thread',
    path: '/fonctionnalites/themes',
    defaults: {
      metaTitle: 'Thèmes personnage & thread | Earth Forum',
      metaDescription: 'Personnalisez les couleurs et le filigrane de vos personnages et discussions.',
    },
  },
];

const ImportantSeoFeatures = () => {
  const [selectedPageKey, setSelectedPageKey] = useState(FEATURE_PAGES[0].pageKey);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [seo, setSeo] = useState(EMPTY_SEO);

  const selectedPage = useMemo(
    () => FEATURE_PAGES.find((page) => page.pageKey === selectedPageKey) || FEATURE_PAGES[0],
    [selectedPageKey],
  );

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await seoAdminService.getSitePage(selectedPageKey);
        setSeo({ ...EMPTY_SEO, ...(data?.seo || {}) });
      } catch (err) {
        message.error('Impossible de charger le SEO des fonctionnalités.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedPageKey]);

  const save = async () => {
    try {
      setSaving(true);
      await seoAdminService.saveSitePage(selectedPageKey, { seo });
      message.success('SEO enregistré.');
    } catch (err) {
      message.error('Erreur lors de la sauvegarde.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card loading={loading} title="SEO — Fonctionnalités">
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Text type="secondary">
          Optimisez le référencement des pages fonctionnalités (partages Discord, réseaux sociaux, Google).
        </Text>
        <Select
          value={selectedPageKey}
          onChange={setSelectedPageKey}
          style={{ width: '100%', maxWidth: 420 }}
          options={FEATURE_PAGES.map((page) => ({
            value: page.pageKey,
            label: page.label,
          }))}
        />
        <SeoFieldsPanel
          value={seo}
          onChange={setSeo}
          collapsible={false}
          pageUrl={`${FRONTEND_URL}${selectedPage.path}`}
          defaults={selectedPage.defaults}
        />
        <Button type="primary" onClick={save} loading={saving}>
          Enregistrer
        </Button>
      </Space>
    </Card>
  );
};

export default ImportantSeoFeatures;
